export default {
  Student: {
    Title: 'Học sinh',
    AddStudent: 'Thêm học sinh',
    DateBirth: 'Ngày sinh',
    Name: 'Tên',
    PhoneNumber: 'Số điện thoại',
    ParentName: 'Họ tên phụ huynh',
    ParentPhoneNumber: 'Số điện thoại phụ huynh',
    SearchStudent: 'Nhập tên học sinh để tìm kiếm',
    StudentCode: 'Mã học sinh',
    SelectTargetClass: 'Thêm học sinh vào lớp riêng',
    EnterStudentNameStudentCode: 'Nhập tên/mã học sinh',
    InformationStudent: 'Thông tin học sinh',
    AddToClass: 'Thêm vào lớp',
    Avatar: 'Ảnh đại diện',
    ChoseClassMove: 'Chọn lớp được chuyển tới',
    FullName: 'Họ tên',
    Sex: 'Giới tính',
    NotFoundStudent: 'Không tìm thấy học sinh',
    RemoveFromClass: 'Xóa khỏi lớp',
    ResetPassword: 'Đặt lại mật khẩu',
    DetailStudent: 'Chi tiết học sinh',
    WaitingApproval: '{count} chờ phê duyệt',
    WaitingListForConfirmation: 'Danh sách đang chờ xác nhận',
    ViewMore: 'Xem thêm',
    NoStudentInClass: 'Chưa có học sinh',
    PendingStudents: 'Danh sách học sinh chờ phê duyệt ({total})',
    JoinStudents: 'Danh sách học sinh đã tham gia ({total})',
    RemoveStudent: 'Xóa học sinh',
    ConfirmRemoveStudent: 'Bạn có muốn xóa học sinh <b>{studentName}</b> ra khỏi lớp <b>{className}</b> không?',
    AprroveAll: 'Phê duyệt tất cả',
    JoinedStudent: 'HS đã tham gia ({total})',
    UnJoinedStudent: 'HS chưa tham gia ({total})',
    ConsiderStudent: 'HS cần phê duyệt ({total})',
    SisapCode: 'Mã SISAP: {SISAPCode}'

  }
}
